import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { Counter } from './features/counter/Counter';
import Login from './features/login/Login';
import Home from './features/home/Home';
import './App.css';
import { Loader } from './components/loader/Loader';
import { Signup } from './features/signup/Signup';
import LandingPage from './features/landing/sections/LandingPage';
import TermsOfService from './features/landing/sections/TermsOfService';
import PrivacyPolicy from './features/landing/sections/PrivacyPolicy';
import { useMediaQuery } from 'react-responsive';
import MobileLanding from './features/mobile/sections/MobileLanding';
import MobileHome from './features/mobileDashboard/home/MobileHome';
import MobileDashboard from './features/mobileDashboard/dashboard/MobileDashboard';
import { Dashboard } from './features/dashboard/Dashboard';


function App() {

  const isMobileLanding = useMediaQuery({ query: '(max-width: 768px)' });
  const isMobileDashboard = useMediaQuery({ query: '(max-width: 600px)' });

  return (
    <div className="">
      <Loader />
      <Router>
        <Switch>

          <Route path='/login' component={Login} exact></Route>
          <Route path='/signup' component={Signup} exact></Route>
          <Route path='/counter' component={Counter} exact></Route>
          <Route path='/home' exact component={isMobileDashboard ? MobileDashboard : Dashboard}></Route>
          <Route path='/home/:feature' component={isMobileDashboard ? MobileHome : Home}></Route>

          <Route path='/landing-page' component={isMobileLanding ? MobileLanding : LandingPage} exact ></Route>
          <Route path='/terms' component={TermsOfService} exact></Route>
          <Route path='/privacy' component={PrivacyPolicy} exact></Route>

          {/* <Route path='/'>
            <Redirect to='/login'/>
          </Route>
          <Route path="/*">
            <Redirect to='/login'/>
          </Route> */}

          <Route path='/'>
            <Redirect to='/landing-page' />
          </Route>
          <Route path="/*">
            <Redirect to='/landing-page' />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;


